<template>
  <div class="section haze full-height">
    <div class="wrapper vertical-center">
      <div class="middle" />
      <div class="contact-v1">
        <div class="intro">
          <h2 class="volk volk-center">
            <span class="text-span-6">Payment Authentication Needed!</span>
          </h2>
          <div class="divider-2 animated" />
          <div>Thank you for signing up! Your account has been created, but it is not yet active because your payment requires authentication. You will receive an email shortly with a link to complete the checkout process. Once your payment is successfully completed, your account will be activated.<br>Details about your plan and a receipt have been sent to {{ accountOwner.email }}. Our office will reach out to you to schedule an appointment. If you have any questions or would like to set up your own appointment, feel free to call us.<br>If you have any questions, call <a href="#"><strong>{{ company.phone }}</strong></a><br>Or visit <a :href="company.website"><strong>Menu.Dental</strong></a></div>
        </div><a
          href="#"
          class="button margin-top w-button"
        >Return To Menu.Dental</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SignupAuthenticationNeeded',
  props: {
    accountOwner: {
      type: Object,
      default: null,
      required: true
    },
    company: {
      type: Object,
      default: null,
      required: true
    }
  }
}
</script>
